import { Dispatch, SetStateAction } from 'react';
import { FieldEnum } from './useGetAndMapReceivedBills';

const useHandleChangePassiveCycleAssociation = (setReceivedBills: Dispatch<SetStateAction<any[]>>) => {
  const handleChangeValue = (value: any, id: number, indexBill: number) => {
    if (id === FieldEnum.ORDER) {
      setReceivedBills((prev) => {
        console.log(prev);
        return prev.map((el, i) => {
          if (i === indexBill) {
            return {
              ...el,
              numeroOrdine: {
                ...el.numeroOrdine,
                value,
              },
            };
          }
          return el;
        });
      });
    }
    if (id === FieldEnum.PROJECT) {
      setReceivedBills((prev) => {
        console.log(prev);
        return prev.map((el, i) => {
          if (i === indexBill) {
            return {
              ...el,
              progetti: {
                ...el.progetti,
                value,
              },
            };
          }
          return el;
        });
      });
    }
  };

  return { handleChangeValue };
};

export default useHandleChangePassiveCycleAssociation;
